import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useOutletContext } from "react-router-dom";
import "./style.css";

// API
import { createWABA, retryCreateWABA } from "api/apiClients/meta/whatsapp";
import { currentUserDetails } from "../../../../api/Api";

// hooks
import useToggle from "hooks/useToggle";

// redux
import {
  setBrandUserRoles,
  updateCurrentBrand,
  updateCurrentUser,
} from "../../../../reduxToolkit/appSlice";
import {
  useAspDispatch,
  useAspSelector,
} from "../../../../test/jest-redux-hooks";

// components
import CreateWABALoader from "components/commonComponents/createWABALoader";
import CreateWABAError from "components/commonComponents/createWABALoader/CreateWABAError";
import { configId, solutionID } from "../../../../api/ApiConfig";

import { Button, Flex, Space, Typography, Alert, Divider } from "antd";
// import WhatsAppConnectionModal from "./components/WhatsAppConnectionModal";
import { ICONS } from "../../../../assets/icons";
import { InfoCircleOutlined } from "@ant-design/icons";
const { Paragraph, Text, Title } = Typography;

import Whatsapp_connections from "../../../../assets/icons/Whatsapp_connections.svg";
import { getWhatsappBusinessProfile } from "../../../../reduxToolkit/channelSlice";
const Whatsapp = () => {
  // const { pathname } = useLocation();
  const dispatch = useAspDispatch();

  const navigate = useNavigate();

  // create WABA
  const [sessionData, setSessionData] = useState(null);
  const [data, setData] = useState(null);
  const [isRes, setIsRes] = useToggle(false);
  const [isResError, setIsResError] = useState({
    error: false,
    data: "",
  });
  const [isFbWizardOpen, setIsFbWizardOpen] = useState(false);
  // const [isSelectionModalOpen, setIsSelectionModalOpen] = useState(false);
  const [connectionType, setConnectionType] = useState('bsp');
  const [res, setRes] = useState(null);

  const { syncing, setSyncing, dataList, isLoading, onClick } =
    useOutletContext();

  const { currentBrand, currentAccount } = useAspSelector(
    (state) => state?.app,
  );

  useEffect(() => {
    window.addEventListener("message", sessionInfoListener);

    return () => {
      window.removeEventListener("message", sessionInfoListener);
    };
  }, []);

  useEffect(() => {
    if ((currentBrand?.is_whatsapp_connected && currentBrand?.brand_mode === 'live') || 
    (!currentBrand?.is_whatsapp_connected && currentBrand?.brand_mode === 'test')) {
      dispatch(
        getWhatsappBusinessProfile({
          brand_id: currentBrand?.brand_id,
          platform_name: "wapp",
        }),
      );
    }
  }, [currentBrand?.is_whatsapp_connected, currentBrand?.brand_mode]);

  useEffect(() => {
    if (sessionData && data) {
      const payload = {
        brand_id: currentBrand?.brand_id,
        waba_id: sessionData?.waba_id,
        phone_number_id: sessionData?.phone_number_id,
        code: data?.authResponse?.code,
        connection_type: connectionType === 'bsp' ? 'bsp' : 'meta'
      };
      createWhatsappAccount(payload);
    }
  }, [data, sessionData]);

  const sessionInfoListener = (event) => {
    if (
      event.origin !== "https://www.facebook.com" &&
      event.origin !== "https://web.facebook.com"
    ) {
      return;
    }
    try {
      const data = JSON.parse(event.data);
      if (data.type === "WA_EMBEDDED_SIGNUP") {
        if (data.event === "FINISH") {
          const { phone_number_id, waba_id } = data.data;
          setSessionData(data?.data);
        } else {
          const { current_step } = data.data;
        }
      }
    } catch {
      console.warn("Non JSON Response", event.data);
    }
  };

  // launch the meta embedded signup window
  async function launchWhatsAppSignup() {
    // Uncomment below to show modal for connection type selection
    // setIsSelectionModalOpen(true);
    // return;
    
    // Direct BSP connection (bypassing modal)
    let data = null;
    const type = 'bsp'; // Default to BSP connection type
    setConnectionType(type);
    setIsFbWizardOpen(true);
    await FB.login(
      function (response) {
        setIsFbWizardOpen(false);

        if (response.authResponse) {
          const code = response.authResponse.code;
          setData(response);
        } else {
          console.warn("User cancelled login or did not fully authorize.");
        }
      },
      {
        config_id: configId,
        response_type: "code",
        override_default_response_type: true,
        extras: {
          sessionInfoVersion: 3,
          version: "v3",
          setup: { solutionID: solutionID }, // Always use BSP with solutionID
          features: [
            {
              name: "marketing_messages_lite"
            }
          ]
        },
      },
    );

    return data;
  }

  // connecting the webhook
  const createWhatsappAccount = async (payload) => {
    setIsRes(true);
    setIsResError(false);
    try {
      const res = await createWABA(payload);
      setRes(res?.data);
      if (res?.status === 200) {
        await fetchCurrentUserDetails();
        setIsRes(false);
        // setIsResError(false);
      } else {
        const data = {
          error: true,
          data: res?.response?.data?.error,
        };
        setIsResError(data);
      }
    } catch (e) {
      console.warn(e);
      setRes(null);
    }
  };

  // if failed to connect the webhook
  const retryWABACreate = async () => {
    setIsRes(true);
    setIsResError({
      error: false,
      data: "",
    });
    try {
      const res = await retryCreateWABA({
        brand_id: currentBrand?.brand_id,
        connection_type: connectionType === 'bsp' ? 'bsp' : 'meta'
      });
      if (res.status === 200) {
        const newRes = await fetchCurrentUserDetails();
        if (newRes?.status === 200) {
          window.location.reload();
          setIsRes(false);
        }
        await fetchCurrentUserDetails();
        setIsRes(false);
      } else {
        setIsResError({
          error: true,
          data: res?.response?.data?.error,
        });
      }
    } catch (e) {
      console.warn(e);
    }
  };

  const fetchCurrentUserDetails = async () => {
    try {
      const res = await currentUserDetails();
      dispatch(setBrandUserRoles(res?.data));
      dispatch(updateCurrentUser(res?.data));
      const account = res?.data?.active_accounts?.find(
        (aa) => aa?.account_id === currentAccount?.account_id,
      );

      const checkBrandExist = account?.brands?.filter(
        (b) =>
          b?.brand_id === currentBrand?.brand_id &&
          b?.is_whatsapp_connected !== currentBrand?.is_whatsapp_connected,
      );

      setIsRes(false);
      if (checkBrandExist?.length > 0) {
        dispatch(updateCurrentBrand(checkBrandExist?.[0]));
        dispatch(updateCurrentUser(res?.data));
      } else {
        dispatch(updateCurrentBrand(account?.brands?.[0]));
      }
      navigate("/user/channels/whatsapp/insights");
    } catch (error) {
      setIsRes(false);
      console.warn("Error fetching current user details:", error);
    }
  };

  return (
    <>
      {(currentBrand?.is_whatsapp_connected && currentBrand?.brand_mode === 'live') || 
        (!currentBrand?.is_whatsapp_connected && currentBrand?.brand_mode === 'test') ? (
        <Outlet
          context={{ syncing, setSyncing, dataList, isLoading, onClick }}
        />
      ) : (
        <Flex className="p-6 bg-white rounded-lg min-h-[calc(100vh-64px)]">
          {isRes ? (
            <div
              className={`w-full h-full absolute top-0 left-0 flex flex-col items-center justify-center `}
            >
              {isResError?.error ? (
                <>
                  <CreateWABAError width={"11vw"} height={"6vw"} />
                  <p
                    className={`font-large weight-semibold mt-6 ${
                      ["payment", "two-factor"]?.includes(isResError?.data)
                        ? "text-[var(--primary)]"
                        : "text-[#F96056]"
                    }`}
                  >
                    {isResError?.data === "payment"
                      ? 'Please configure the payment method and click "continue".'
                      : isResError?.data === "two-factor"
                      ? "Please remove your 2-factor authentication from the WhatsApp manager and click continue."
                      : "Unexpected error happen, please retry!"}
                  </p>
                  <button
                    className={`font-md weight-medium text-[#F96056] font-normal weight-bold px-[0.85vw] py-[0.4vw] rounded-[0.6vw] mt-[0.8vw] ${
                      ["payment", "two-factor"]?.includes(isResError?.data)
                        ? "bg-[var(--primary)] text-white"
                        : "bg-red-500 text-white"
                    }`}
                    onClick={() => {
                      retryWABACreate();
                    }}
                  >
                    {["payment", "two-factor"]?.includes(isResError?.data)
                      ? "Continue"
                      : "Retry"}
                  </button>
                </>
              ) : (
                <>
                  <CreateWABALoader width={"11vw"} height={"6vw"} />
                  <p className="font-large weight-semibold bg-gradient-to-r from-[#0ACD95] to-[#6940F2] bg-clip-text text-transparent">
                    Hold on, we&apos;re setting up things for you.
                  </p>
                </>
              )}
            </div>
          ) : (
            <Flex vertical gap={20}>
              <Space direction="vertical" className="w-full">
                <Space align="center">
                  <Flex justify="center" align="center" gap="small">
                    <img src={ICONS.whatsappLeft} alt="" className="size-10" />
                    <Title level={4} style={{ margin: 0 }}>
                      WhatsApp Business Platform (API)
                    </Title>
                  </Flex>
                </Space>

                <Paragraph
                  type="secondary"
                  className="max-w-[75%]"
                  style={{ marginBottom: 0 }}
                >
                  Link up the WhatsApp Business Platform (API) through Facebook
                  to make chatting with customers easier, boost sales, and
                  improve support!
                </Paragraph>
                <Paragraph type="secondary" className="max-w-[75%]">
                  Connect the WhatsApp Business Platform (API) via Facebook to
                  chat with your customers more easily, increase sales, and
                  enhance support!
                </Paragraph>
                <Space size="middle">
                  <Button
                    type="primary"
                    loading={isFbWizardOpen}
                    disabled={isFbWizardOpen}
                    className="bg-blue-600"
                    onClick={launchWhatsAppSignup}
                  >
                    {"Continue with Facebook"}
                  </Button>

                  <Button type="link" className="text-gray-500">
                    Watch Demo →
                  </Button>
                </Space>
              </Space>

              <Divider className="m-0" />

              <Title level={5}>What you will need:</Title>
              <div className="max-w-[25vw]">
                <img src={Whatsapp_connections} alt="" />
              </div>

              <Title level={5} style={{ marginBottom: 0 }}>
                Channel requirements:
              </Title>
              <Space direction="vertical" className="w-[75%]">
                <Text className="text-xs">
                  <Text strong>1. A phone number:</Text> Keep your business
                  phone number handy to receive OTP! It's important this number
                  is not connected to any WhatsApp account.
                </Text>
                <Text className="text-xs">
                  <Text strong>2. Access to a personal Facebook account:</Text>{" "}
                  That has been added to the Meta Business Suite for your
                  business with admin rights.
                </Text>
                <Text className="text-xs">
                  <Text strong>3. A profile picture:</Text> File format: PNG or
                  JPEG. Optimal dimension 640x640 pixels.
                </Text>
              </Space>

              <Alert
                message="Don't have all you need to install WhatsApp?"
                type="info"
                showIcon
                icon={<InfoCircleOutlined />}
                className="mt-4 w-[75%]"
                action={<Button type="link">View Guide</Button>}
              />
            </Flex>
          )}
        </Flex>
      )}

      {/* Uncomment to enable modal-based connection type selection */}
      {/* Also update launchWhatsAppSignup to accept 'type' parameter and remove direct FB.login call */}
      {/* <WhatsAppConnectionModal
        open={isSelectionModalOpen}
        onCancel={() => setIsSelectionModalOpen(false)}
        onSelect={launchWhatsAppSignup}
      /> */}
    </>
  );
};

export default Whatsapp;
